import { version } from '../../package.json';
export default version;


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_antd@3.15.2@antd/es/version/index.js
// module id = 1052
// module chunks = 0